import { useNavigation } from '@react-navigation/native';
import React from 'react'

import {
  StyleSheet,
  View,
  Image,
  ScrollView,
  Platform,
  Text,
} from 'react-native';

import LoginForm from '../components/authentication/LoginForm';
import Button from '../components/ui/Button';

interface Props {
}

const UnauthorizedScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <Text style={styles.title}>You are not authorized to access this site</Text>
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default UnauthorizedScreen